module.exports = __webpack_public_path__ + "static/media/400288_01.fcdbfae4.png";